// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DUPM","content":"styles_content__2BVgS","row":"styles_row__3yCLT","footer":"styles_footer__2F5PB","phraseLength":"styles_phraseLength__3Xj_K"};